import Modal from 'react-modal'
import React from 'react'
import { Button } from 'loyal-react'
import PropTypes from 'prop-types'
// import CSVReader from 'react-csv-reader'
// import { parseOptions } from '../Shared/utils'
// import { toast } from 'react-toastify'
import { CSVReader } from 'react-papaparse'

const CsvModal = ({
  modal,
  participant,
  toggleModal,
  updateState,
  submit,
  downloadModelo,
  uploadCallback,
  handleOnFileLoad,
  handleOnError,
  handleOpenDialog,
  buttonRef
}) => {
  return (
    <Modal
      isOpen={modal}
      onRequestClose={toggleModal}
      style={{
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          width: '600px'
        }
      }}
    >
      <div className='row'>
        <div className='col-12'>
          <h2 className='txt-initial color-brand-1 mr-auto'>
            Importar CSV
          </h2>
        </div>
      </div>
      <hr />
      <div className='row mt-2'>
        <div className='col-12'>
          <Button
            block outline
            text='Modelo CSV'
            color='success'
            type='button'
            className='float-right btn-block'
            onClick={() => { downloadModelo() }}
          >
            Modelo CSV
          </Button>
        </div>
      </div>
      <div className='row mt-2'>
        <div className='col-12'>
          {/* <CSVReader
            onFileLoaded={(data, fileInfo) => uploadCallback(data)}
            onError={() => toast.error('Não foi possível processar o CSV!')}
            parserOptions={parseOptions}
          /> */}
          <CSVReader
            ref={buttonRef}
            onFileLoad={handleOnFileLoad}
            onError={handleOnError}
            noClick
            noDrag
          >
            {({ file }) => (
              <div>
                <Button
                  type='button'
                  text='Escolher arquivo'
                  onClick={handleOpenDialog}
                />
                {file &&
                (
                  <div
                    style={{
                      borderWidth: 1,
                      borderStyle: 'solid',
                      borderColor: '#ccc',
                      height: 45,
                      lineHeight: 2.5,
                      marginTop: 5,
                      marginBottom: 5,
                      paddingLeft: 13,
                      paddingTop: 3
                    }}
                  >
                    {file && file.name}
                  </div>
                )}
              </div>
            )}
          </CSVReader>
        </div>
      </div>
      <div className='row mt-2'>
        <div className='col'>
          <Button
            id='closeModal'
            name='closeModal'
            className='btn btn-sm mx-0'
            text='Fechar'
            onClick={() => toggleModal('csvModal')}
          />
        </div>
      </div>
    </Modal>
  )
}

CsvModal.propTypes = {
  modal: PropTypes.bool,
  participant: PropTypes.object,
  toggleModal: PropTypes.func,
  updateState: PropTypes.func,
  submit: PropTypes.func,
  downloadModelo: PropTypes.func,
  uploadCallback: PropTypes.func,
  handleOnFileLoad: PropTypes.func,
  handleOnError: PropTypes.func,
  handleOpenDialog: PropTypes.func,
  buttonRef: PropTypes.object
}

export default CsvModal



// WEBPACK FOOTER //
// ./src/features/FocalPoint/Participant/CsvModal.js